import BaseEntity from '../../base/BaseEntity.model';

export default class TramiteCambioJefeHogar extends BaseEntity {
    public razon?: string;
    public razonPorQueDebeSerNuevoJefe?: string;
    public razonMuerte?: string;
    public fechaFallecimiento?: Date;
    public tramiteBeneficiarioId?: number;
    public tipoDiscapacidadId?: number;
    public tipoDiscapacidadNombre?: string;
    public razonPorqueEntregaTarjeta?: string;
    public fechaAbandonoHogar?: Date;
    constructor(public jefeHogarId: number | undefined = undefined) {
        super();
        this.razon = undefined;
        this.tramiteBeneficiarioId = undefined;
        this.razonPorQueDebeSerNuevoJefe = undefined;
        this.razonMuerte = undefined;
        this.fechaFallecimiento = undefined;
        this.tipoDiscapacidadId = undefined;
        this.tipoDiscapacidadNombre = undefined;
        this.razonPorqueEntregaTarjeta = undefined;
        this.jefeHogarId = undefined;
    }
}